import type { Image } from '@/shared/cms/shared';

type ImageRendererProps = {
    image: Image | string;
    className?: string;
};

export function ImageRenderer({ image, className }: ImageRendererProps) {
    const base = process.env['ALGOTECH_CMS_URL'];

    if (typeof image === 'string') return null;

    return (
        <img
            alt={image.alt || undefined}
            className={className}
            src={`${base}${image.url}`}
        />
    );
}

ImageRenderer.displayName = 'ImageRenderer';
